import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import CoursePage from "./pages/CoursePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import Terms from "./pages/Terms";
import NoteLegali from "./pages/NoteLegali";
import LoginSoci from "./pages/LoginSoci";
import DashboardSoci from "./pages/DashboardSoci";
import AdminPanel from "./pages/AdminPanel";
import DirettivoDocumentazione from "./pages/DirettivoDocumentazione";
import RegistroNazionale from "./pages/RegistroNazionale";
import VerificaSocio from "./pages/VerificaSocio";
import AuthCallback from "./pages/AuthCallback";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import TestPagamento from "./pages/TestPagamento";
import BlogList from "./pages/BlogList";
import BlogArticle from "./pages/BlogArticle";
import EventiList from "./pages/EventiList";
import EventoDetail from "./pages/EventoDetail";
import EventoFeedback from "./pages/EventoFeedback";
import OpportunitaExtra from "./pages/OpportunitaExtra";
import ResetPassword from "./pages/ResetPassword";
import CorsoAIActLiteracy from "./pages/CorsoAIActLiteracy";
import VerificaAttestato from "./pages/VerificaAttestato";
import CookieBanner from "./components/CookieBanner";
import StickyCTA from "./components/StickyCTA";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/corso" element={<CoursePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/termini-e-condizioni" element={<Terms />} />
          <Route path="/note-legali" element={<NoteLegali />} />
          <Route path="/area-soci" element={<LoginSoci />} />
          <Route path="/dashboard" element={<DashboardSoci />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/direttivo-documentazione" element={<DirettivoDocumentazione />} />
          <Route path="/registro-nazionale" element={<RegistroNazionale />} />
          <Route path="/verifica/:numero" element={<VerificaSocio />} />
          <Route path="/auth-callback" element={<AuthCallback />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/annullato" element={<CheckoutCancel />} />
          <Route path="/test-pagamento" element={<TestPagamento />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/eventi" element={<EventiList />} />
          <Route path="/eventi/:slug" element={<EventoDetail />} />
          <Route path="/feedback/eventi/:token" element={<EventoFeedback />} />
          <Route path="/opportunita-extra" element={<OpportunitaExtra />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/corsi/ai-act-literacy" element={<CorsoAIActLiteracy />} />
          <Route path="/verifica-attestato" element={<VerificaAttestato />} />
        </Routes>
        <CookieBanner />
        <StickyCTA />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
